import { atom } from 'jotai';

export const branchUpdaterKey = atom(0);
